
import Interaction from 'ol/interaction/Interaction';
import MapBrowserEventType from 'ol/MapBrowserEventType';

class NahlizeniDoKn extends Interaction {

    constructor(opt_options) {
        const options = opt_options ? opt_options : {};
        super(options);

        if (options.handleClickEvent) {
            this.handleClickEvent = options.handleClickEvent;
        }
    }

    handleClickEvent(mapBrowserEvent) {
        return false;
    }

    handleEvent(mapBrowserEvent) {
        let stopEvent = false;
        if (mapBrowserEvent.type == MapBrowserEventType.CLICK) {
            const browserEvent = mapBrowserEvent.originalEvent;
            this.handleClickEvent(mapBrowserEvent);
            browserEvent.preventDefault();
            stopEvent = true;
        }
        return !stopEvent;
    }
}

async function processClick(mapBrowserEvent, options) {
    const x = Math.floor(mapBrowserEvent.coordinate[0]);
    const y = Math.floor(mapBrowserEvent.coordinate[1]);
    const url = `https://nahlizenidokn.cuzk.cz/MapaIdentifikace.aspx?x=${x}&y=${y}`;
    window.open(url, 'cuzk');    
}

function createInteractionKn(options) {

    let interaction = new NahlizeniDoKn({
        handleClickEvent: async (mapBrowserEvent) => {
            await processClick(mapBrowserEvent, options);
        }
    });

    interaction.set('mapToolId', 'Kn');
    interaction.setActive(false);

    return interaction;
}

export default createInteractionKn;
